const saveToLocalStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const loadFromLocalStorage = (key: string) => {
  const data = localStorage.getItem(key);
  if (!data) {
    return null;
  }
  return JSON.parse(data);
};

const saveToSessionStorage = (key: string, value: any) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

const loadFromSessionStorage = (key: string) => {
  const data = sessionStorage.getItem(key);
  if (!data) {
    return null;
  }
  return JSON.parse(data);
};

/** Carrega user: primeiro localStorage (manter logado), depois sessionStorage (sessão). */
const loadUserFromStorage = (key: string) => {
  const fromLocal = loadFromLocalStorage(key);
  if (fromLocal && fromLocal !== '') {
    return fromLocal;
  }
  return loadFromSessionStorage(key);
};

const clearUserStorage = (key: string) => {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};

export {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToSessionStorage,
  loadFromSessionStorage,
  loadUserFromStorage,
  clearUserStorage,
};
